export default __webpack_public_path__ + "static/media/ALIGN_LEFT_pressed.ee5757ec.svg";